import React, { useEffect, useState } from "react";
import styled from "styled-components";
import CommonModal from "../based/Modal";
import TFUSelect from "../based/inputs/TFUSelect";
import Textbox from "../based/inputs/Textbox";
import CheckBox from "../based/inputs/CheckBox";
import TextArea from "../based/inputs/TextArea";
import TextNumber from "../based/inputs/TextNumber";
import PartnerServices from "../based/services/PartnerServices";
import { Notify } from "../based/Notify";
import { NOTIFY } from "../based/Constants";

const CostDiscountType = {
    Fixed: 0,
    Voucher: 1,
    Marketing: 2,
    Other: 3,
};

export const VoucherDiscountType = {
    Percentage: 0,
    FixedPrice: 1,
};

export const ListCostDiscountType = [
    {
        value: CostDiscountType.Fixed,
        label: "Phí Cố định (Phí bắt buộc phải có)",
    },
    {
        value: CostDiscountType.Voucher,
        label: "Phí Voucher (Vận chuyển, voucher extra)",
    },
    {
        value: CostDiscountType.Marketing,
        label: "Phí Marketing (Flashsale, TTLK, Chạy quảng cáo)",
    },
    {
        value: CostDiscountType.Other,
        label: "Phí khác (KOL, Vận hành...)",
    },
];

export const ListVoucherDiscountType = [
    {
        value: VoucherDiscountType.Percentage,
        label: "Phần trăm",
    },
    {
        value: VoucherDiscountType.FixedPrice,
        label: "Giá cố định",
    },
];

function PartnerCostModal({ show, onClose, onSave, modalId }) {
    const [model, setModel] = useState({});
    const [modelValue, setModelValue] = useState({});

    useEffect(() => {
        if (modalId > 0) getModel(modalId);
        else {
            setModel({});
            setModelValue({});
        }
    }, [modalId, show]);

    const handleSave = async () => {
        const [err, data] = await PartnerServices.CreateUpdatePartnerCostDiscount({ ...model, partnerCostDiscountValue: modelValue });
        if (!err && data) {
            Notify(NOTIFY.SUCCESS, "Thành công", "Thêm phí thành công");
            onSave();
        } else {
            Notify(NOTIFY.ERROR, "Thất bại", "Thêm phí thất bại");
        }
    };

    const getModel = async (modalId) => {
        const [err, data] = await PartnerServices.GetPartnerCostDiscountById(modalId);
        if (!err && data) {
            setModel(data);
            setModelValue(data.partnerCostDiscountValue);
        } else {
            Notify(NOTIFY.ERROR, "Thất bại", "Lấy phí thất bại");
        }
    };

    return (
        <CommonModal show={show} onClose={onClose} title={modalId == 0 ? "Thêm phí" : "Chỉnh sửa"} size="md" hiddenFooter>
            <Wrapper>
                <div className="form-group">
                    <label htmlFor="" className="required">
                        Tên loại phí
                    </label>
                    <TFUSelect
                        placeholder="Chọn loại phí"
                        name="costDiscountType"
                        options={ListCostDiscountType}
                        onChanged={(newVal) => {
                            setModel({ ...model, discountType: newVal });
                        }}
                        value={model.discountType}
                    />
                </div>
                <div className="form-group">
                    <label htmlFor="" className="required">
                        Tên phí cố định
                    </label>
                    <Textbox
                        placeholder="Nhập tên chi phí"
                        value={model.name}
                        name="name"
                        id="name"
                        onChanged={(name, value) => {
                            setModel({ ...model, name: value });
                        }}
                    />
                </div>
                <div className="form-group select-price">
                    <div className="label-section my-2">
                        <label htmlFor="" className="required">
                            Chọn phí trong Combo (Ít nhất 2)
                        </label>
                        <div className="ml-auto" style={{ width: "120px" }}>
                            <TFUSelect
                                placeholder="Chọn loại"
                                name="valueType"
                                id="valueType"
                                options={ListVoucherDiscountType}
                                value={model.valueType}
                                onChanged={(newVal) => {
                                    setModel({ ...model, valueType: +newVal });
                                }}
                            />
                        </div>
                    </div>
                    <div className="table-shop">
                        <table className="table table-bordered">
                            <thead>
                                <tr>
                                    <th className="center">Loại shop</th>
                                    <th className="center required">Phần trăm phí</th>
                                    <th className="center">Phí tối đa</th>
                                    <th className="center">Tùy chỉnh</th>
                                </tr>
                            </thead>
                            <tbody>
                                <tr>
                                    <td className="vertical-align-middle">Shop thường</td>
                                    <td className="vertical-align-middle">
                                        <TextNumber
                                            placeholder="Nhập"
                                            name="normalShopValue"
                                            id="normalShopValue"
                                            value={modelValue.normalShopValue}
                                            onChanged={(name, value) => {
                                                setModelValue({ ...modelValue, normalShopValue: value });
                                            }}
                                            suffix={model.valueType == VoucherDiscountType.Percentage ? "%" : "đ"}
                                            decimal
                                        />
                                    </td>
                                    <td className="vertical-align-middle">
                                        <TextNumber
                                            placeholder="Nhập"
                                            name="normalShopMaximum"
                                            id="normalShopMaximum"
                                            value={modelValue.normalShopMaximum}
                                            onChanged={(name, value) => {
                                                setModelValue({ ...modelValue, normalShopMaximum: value });
                                            }}
                                            suffix={"đ"}
                                            decimal
                                        />
                                    </td>
                                    <td className="vertical-align-middle">
                                        <CheckBox
                                            name="normalShopEditable"
                                            id="normalShopEditable"
                                            checked={modelValue.normalShopEditable}
                                            onCheckedChange={(name, value) => {
                                                setModelValue({ ...modelValue, normalShopEditable: value });
                                            }}
                                        />
                                    </td>
                                </tr>
                                <tr>
                                    <td className="vertical-align-middle">Shop mall</td>
                                    <td className="vertical-align-middle">
                                        <TextNumber
                                            placeholder="Nhập"
                                            name="mallShopValue"
                                            id="mallShopValue"
                                            value={modelValue.mallShopValue}
                                            onChanged={(name, value) => {
                                                setModelValue({ ...modelValue, mallShopValue: value });
                                            }}
                                            suffix={model.valueType == VoucherDiscountType.Percentage ? "%" : "đ"}
                                            decimal
                                        />
                                    </td>
                                    <td className="vertical-align-middle">
                                        <TextNumber
                                            placeholder="Nhập"
                                            name="mallShopMaximum"
                                            id="mallShopMaximum"
                                            value={modelValue.mallShopMaximum}
                                            onChanged={(name, value) => {
                                                setModelValue({ ...modelValue, mallShopMaximum: value });
                                            }}
                                            suffix={"đ"}
                                            decimal
                                        />
                                    </td>
                                    <td className="vertical-align-middle">
                                        <CheckBox
                                            name="mallShopEditable"
                                            id="mallShopEditable"
                                            checked={modelValue.mallShopEditable}
                                            onCheckedChange={(name, value) => {
                                                setModelValue({ ...modelValue, mallShopEditable: value });
                                            }}
                                        />
                                    </td>
                                </tr>
                            </tbody>
                        </table>
                    </div>
                </div>
                <div className="form-group">
                    <label htmlFor="">Nội dung</label>
                    <TextArea
                        placeholder="Nhập nội dung"
                        value={model.description}
                        name="description"
                        id="description"
                        onChanged={(name, value) => {
                            setModel({ ...model, description: value });
                        }}
                    />
                </div>
                <div className="form-group">
                    <label htmlFor="">Link chi tiết</label>
                    <Textbox
                        placeholder="Nhập link"
                        value={model.linkDetail}
                        name="linkDetail"
                        id="linkDetail"
                        onChanged={(name, value) => {
                            setModel({ ...model, linkDetail: value });
                        }}
                    />
                </div>
                <div className="list-action-button">
                    <button
                        className="btn btn-danger m-1"
                        onClick={(e) => {
                            e.preventDefault();
                            onClose();
                        }}
                    >
                        Đóng
                    </button>
                    <button
                        className="btn btn-custom m-1"
                        onClick={(e) => {
                            e.preventDefault();
                            handleSave();
                        }}
                    >
                        Xác nhận
                    </button>
                </div>
            </Wrapper>
        </CommonModal>
    );
}

export default PartnerCostModal;

const Wrapper = styled.div`
    .list-action-button {
        display: flex;
        justify-content: center;
    }

    .label-section {
        display: flex;
        align-items: center;
    }

    .label-section label.required {
        margin: 0;
    }
`;
